import { FC, ReactNode } from 'react';

import ImageBlock from './core/ImageBlock.tsx';
import Header from './core/Header.tsx';
import FormLayout from '../core/FormLayout.tsx';
import HaveTroubleText from '../core/HaveTroubleText.tsx';

type Props = {
  children: ReactNode;
  contentToTop?: boolean;
  title?: string;
  description?: string;
};

const AuthLayout: FC<Props> = ({ children, contentToTop, title, description }) => (
  <FormLayout
    head={<Header />}
    rightBlock={<ImageBlock title={title} description={description} />}
    contentToTop={contentToTop}
  >
    {children}

    <HaveTroubleText />
  </FormLayout>
);

export default AuthLayout;
